define('OutSystems/ReactWidgets/Icon',["require", "exports", "tslib", "OutSystems/ReactView/HtmlTags", "OutSystems/ReactView/Widget", "react"], function (require, exports, tslib_1, HtmlTags_1, Widget_1, React) {
    "use strict";
    Object.defineProperty(exports, "__esModule", { value: true });
    exports.Icon = void 0;
    var Icon = (function (_super) {
        tslib_1.__extends(Icon, _super);
        function Icon() {
            return _super !== null && _super.apply(this, arguments) || this;
        }
        Icon.prototype.render = function () {
            var size = "";
            switch (this.props.iconSize) {
                case 0:
                    size = "1x";
                    break;
                case 1:
                    size = "2x";
                    break;
                case 2:
                    size = "3x";
                    break;
                case 3:
                    size = "4x";
                    break;
                default:
                    size = "1x";
                    break;
            }
            var iconAttributes = {
                "data-icon": "",
                className: (this.props.style ? this.props.style : "") + " fa fa-" + this.props.icon + " fa-" + size,
            };
            this.fillWithBuiltinProperties(iconAttributes);
            return React.createElement(HtmlTags_1.HtmlTags.i, iconAttributes);
        };
        Icon = tslib_1.__decorate([
            Widget_1.WidgetSpec
        ], Icon);
        return Icon;
    }(Widget_1.Widget));
    exports.Icon = Icon;
});
//# sourceMappingURL=Icon.js.map;
